import { Box, Grid, Typography } from "@mui/material";
import fileType from "file-type";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useFetchViewFile } from "../../api/effects/mutations/DataPribadi/useFetchViewFile";
import LoadingScreen from "../../components/LoadingScreen";

export default function ViewUserFilePage() {
  const { FileID } = useParams();
  const [blobURL, setBlobURL] = useState("none");

  const { mutateAsync: GetFile, isLoading } = useFetchViewFile({
    onSuccess(data) {
      setBlobURL(
        URL.createObjectURL(
          new Blob([data], {
            type: fileType(data)?.mime,
          })
        )
      );
    },
    onError(data) {},
  });

  useEffect(() => {
    if (FileID !== undefined) GetFile({ id: FileID });
  }, [FileID]);

  if (isLoading) {
    return <LoadingScreen open={isLoading} />;
  }

  return (
    <Grid container sx={{ height: "100vh" }}>
      {blobURL !== "none" ? (
        <iframe
          title="File"
          src={blobURL}
          style={{ width: "100%", height: "99.5%" }}
        />
      ) : (
        <Typography color="error">File Not Found</Typography>
      )}
    </Grid>
  );
}
